import { Box, IconButton, Tooltip } from '@material-ui/core';
import { ReactNode } from 'react';

import { ApplicationShowSummaryMobileButton } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/ApplicationShowSummaryMobileButton';
import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { ApplicationStep } from '@/components/modules/Application/types/ApplicationStep';
import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { Icon } from '@/components/shared/components/Icon';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { useScreen } from '@/hooks/useScreen';

interface ApplicationStepNavProps {
  onNext?: () => void;
  onPrev?: () => void;
  disableOnNext?: boolean;
  tooltipOnNextDisabled?: ReactNode;
  loading?: boolean;
}

export const ApplicationStepNav = ({
  onNext,
  onPrev,
  disableOnNext,
  tooltipOnNextDisabled,
  loading,
}: ApplicationStepNavProps) => {
  const { md, sm } = useScreen();

  const { step } = useApplicationNavigation();

  const { opened, setOpened, toggleDialog } = useDialog();

  const handleClickBack = () => {
    if (step === ApplicationStep.REFERENCES) {
      setOpened(true);
    } else {
      onPrev && onPrev();
    }
  };

  const onNextButton = (
    <StandardButton
      loading={loading}
      main
      disabled={disableOnNext}
      onClick={onNext}
      style={{ minWidth: sm ? '132px' : 0 }}
      endIcon={!loading ? <Icon size={20}>arrow_forward</Icon> : null}
    >
      <Text tId={'CONTINUE'} />
    </StandardButton>
  );

  const onNextButtonWithTooltip = (
    <Tooltip title={tooltipOnNextDisabled as NonNullable<ReactNode>} enterTouchDelay={0}>
      <span style={{ display: 'flex' }}>{onNextButton}</span>
    </Tooltip>
  );

  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      justifyContent={md ? 'flex-end' : 'space-between'}
      className="appear-anim"
      gridGap={sm ? 16 : 10}
    >
      <Box>
        {onPrev &&
          (sm ? (
            <StandardButton disabled={loading} startIcon={<Icon size={20}>arrow_back</Icon>} onClick={handleClickBack}>
              <Text tId={'BACK'} />
            </StandardButton>
          ) : (
            <IconButton disabled={loading} onClick={handleClickBack}>
              <Icon size={20}>arrow_back</Icon>
            </IconButton>
          ))}
      </Box>
      <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} gridGap={sm ? 16 : 10}>
        <ApplicationShowSummaryMobileButton />
        {onNext && (disableOnNext && tooltipOnNextDisabled ? onNextButtonWithTooltip : onNextButton)}
      </Box>
      {step === ApplicationStep.REFERENCES && onPrev && (
        <ActionDialog
          opened={opened}
          setOpened={setOpened}
          handleClose={toggleDialog}
          Title={<Text tId={'RESTART_APPLICATION'} />}
          onSubmit={onPrev}
          Description={<Text tId={'BACK_NOTICE'} />}
          MainButton={<Text tId={'BACK'} />}
        />
      )}
    </Box>
  );
};
